import { render, staticRenderFns } from "./dyOrderList.vue?vue&type=template&id=38d362fc&scoped=true&"
import script from "./dyOrderList.vue?vue&type=script&lang=js&"
export * from "./dyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./dyOrderList.vue?vue&type=style&index=0&id=38d362fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d362fc",
  null
  
)

export default component.exports